import { FinancialForecastEntry, ForecastGraphData } from './financials.forecast.entities';
import { forEach } from "lodash";
import { Unique } from "../../../../shared/scripts/array-functions";


var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/drilldown')(Highcharts);


export class FinancialForecastBarChart{

    graphData: ForecastGraphData[];
    forecastBarChart: any;
    performedDrilldown: boolean;

    constructor(forecastTEData: FinancialForecastEntry[], forecastPEData: FinancialForecastEntry[]) {
        this.graphData = this.createGraphData(forecastTEData, forecastPEData);

        this.performedDrilldown = false;

        this.setCategoryBarChart(this.graphData);
    }

    private setCategoryBarChart(graphData: ForecastGraphData[]): void {

        $('#forecast-graph').empty();
        $('#forecast-graph').height(this.getChartHeight(graphData.length));

        let series = this.getExpenditureSeries(graphData);

        this.forecastBarChart = Highcharts.chart('forecast-graph', {
            chart: {
                type: 'bar',
                events: {
                    drilldown: (e) => {
                        $('#forecast-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        let clickedCategory: string = e.seriesOptions.id.substring(0, e.seriesOptions.id.indexOf("-")).trim();
                        let undoButton: string = `<button class='btn btn-outline-secondary chart-drillup-btn mr-2'><i class="fas fa-undo"></i></button>`
                        this.forecastBarChart.setTitle({ text: `${undoButton} Displaying deliverables for: ${clickedCategory}` }, null);

                        if (!this.performedDrilldown) {

                            this.performedDrilldown = true;
                        }

                        this.forecastBarChart.reflow();
                        this.forecastBarChart.redraw();

                        $(".chart-drillup-btn").on('click', () => {
                            this.drillupTable();
                        });                                            
                    },
                    drillup: (e) => {
                        $('#forecast-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        this.forecastBarChart.setTitle({ text: 'Click a category to learn more' }, null);

                        if (this.performedDrilldown) {
                            this.performedDrilldown = false;
                        }
                        this.forecastBarChart.reflow();
                        this.forecastBarChart.redraw();
                    }
                },
                zoomType: 'y',
                panning: true,
                marginTop: 70
            },
            credits: { enabled: false },
            title: { text: 'Click a category to learn more', align: 'left', margin: 0, style: { color: 'black', fontSize: '14px' }, useHTML: true },
            tooltip: {
                valuePrefix: '$',
                valueDecimals: 2
                //pointFormat: "$ {point.y:,.2f}"
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.05, // larger value has more space for data labels (default is 0.05)
                //reversedStacks: false,
                title: { text: '' },
                labels: {
                    formatter: function () {
                        //return '$' + this.axis.defaultLabelFormatter.call(this);
                        if (this.value >= 100000) {
                            return '$' + (this.value / 1000000) + 'M'
                        }
                        else {
                            return '$' + this.value;
                        }
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.value >= 100000) {
                            let millionsVal = (this.value / 1000000);
                            let styledVal = Highcharts.numberFormat(millionsVal, 2, '.', ',');
                            return "$" + styledVal + 'M'
                        }
                        else {
                            let styledVal = Highcharts.numberFormat(this.value, 0, '.', ',');
                            return "$" + styledVal
                        }

                    },
                    inside: false, //label issues
                    //crop: false,
                    //overflow: 'none'
                }
            },
            legend: { reversed: false, verticalAlign: 'top' },
            plotOptions: {
                series: {
                    stacking: null,
                    pointWidth: 10,
                },
                bar: {
                    borderWidth: 0,
                    //pointPadding: 20,
                    //groupPadding: 0.5,
                }
            },
            series: series.primarySeries,
            drilldown: {
                drillUpButton: {
                    position: {
                        align: 'left',
                        y: -40,
                        x: -40
                    },
                    theme: {
                        display: 'none'
                    }
                },
                series: series.drillDownSeries
            }
        });
    }

    private getChartHeight(entries: number): number {
        let value: number = 150 + (entries * 30 * 1.5);
        return value;
    }

    private getExpenditureSeries(data: ForecastGraphData[]) {
        let dataLabels: string[] = ['Budget', 'Forecast Spend (Enrollment Projections)', 'Forecast Spend (Enrollment Trends)']; // Readable Data Labels
        let dataLabelIds: string[] = ['budget-series', 'forecastPE-series', 'forecastTE-series']; // Data Label IDs
        let dataFields: string[] = ['budget', 'forecastProj', 'forecastTrend']; // FinanacialGraphData fields mapped to Data Labels
        let seriesColors: string[] = ['#504392', '#CA6876', '#E59F00']; // Colors for each data label

        let drillDownSeries = [];
        let primarySeries = dataLabels.map((label: string, index: number) => {
            let primaryData: any[] = [];
            data.forEach((category: ForecastGraphData) => {

                primaryData.push({
                    name: category.name, // Study Name
                    y: category[dataFields[index]], // Amount of Money (per category)
                    drilldown: category.name + "-" + label // id of relative drilldown
                });

                let filteredRecords: ForecastGraphData[] = category.DrillDown; // Get vendors and other folks assoicated with study
                let detailedDrilldownData: any[] = [];
                filteredRecords.forEach((record: ForecastGraphData) => {
                    detailedDrilldownData.push(
                        [record.name, record[dataFields[index]]] // [Vendor Name, Amount of Money (per category)]
                    );
                });

                drillDownSeries.push({
                    name: label, // Data Label
                    id: category.name + "-" + label, // id to help drilldown
                    data: detailedDrilldownData // [Vendor Name, Amount of Money]
                });
            });

            return {
                id: dataLabelIds[index],
                name: label,
                data: primaryData,
                //drilldown: label,
                color: seriesColors[index],
            };
        });

        return {
            primarySeries: primarySeries,
            drillDownSeries: drillDownSeries
        };
    }


    createGraphData(trendItems: FinancialForecastEntry[], projItems: FinancialForecastEntry[]): ForecastGraphData[] {
        let financialsProj = projItems;
        let financialsTrend = trendItems;
        let categories = Unique(financialsProj.map(financial => financial.Category), true);

        let platforms = ["AUTONOMIC", "VITAL", "NEURO", "SLEEP", "ENERGIZE"];
        let localCategoryItems = [];
        forEach(categories, category => {
            let temp = new ForecastGraphData;
            temp.name = category;

            let budget = 0;
            let forecastProj = 0;
            let forecastTrend = 0;

            forEach(platforms, platform => {
                const monthsProj = Unique(financialsProj.filter(financial => financial.Platform == platform).map(financial => financial.Projection_Date), true).sort((a, b) => { return new Date(a).getTime() - new Date(b).getTime(); });
                const finalMonthProj = monthsProj[monthsProj.length - 1];
                const monthsTrend = Unique(financialsTrend.filter(financial => financial.Platform == platform).map(financial => financial.Projection_Date), true).sort((a, b) => { return new Date(a).getTime() - new Date(b).getTime(); });
                const lastMonthTrend = monthsTrend[monthsTrend.length - 1];
                budget += Math.round(financialsProj.filter(financial => financial.Category == category && financial.Platform == platform && financial.Projection_Date == finalMonthProj).reduce((acc, item) => acc + item.cost_budgeted, 0));
                forecastProj += Math.round(financialsProj.filter(financial => financial.Category == category && financial.Platform == platform && financial.Projection_Date == finalMonthProj).reduce((acc, item) => acc + item.Projected_Spending, 0));
                forecastTrend += Math.round(financialsTrend.filter(financial => financial.Category == category && financial.Platform == platform && financial.Projection_Date == lastMonthTrend).reduce((acc, item) => acc + item.Projected_Spending, 0));
            });
            temp.budget = budget;
            temp.forecastProj = forecastProj;
            temp.forecastTrend = forecastTrend;

            let drilldowns: ForecastGraphData[] = [];
            let categoryItemsProj = financialsProj.filter(financial => financial.Category == category);
            let categoryItemsTrend = financialsTrend.filter(financial => financial.Category == category);
            let deliverables = Unique(categoryItemsProj.map(financial => financial.Deliverable), true);

            forEach(deliverables, deliverable => {
                let tempDeliverable = new ForecastGraphData;


                let budget = 0;
                let forecastProj = 0;
                let forecastTrend = 0;

                forEach(platforms, platform => {
                    const monthsProj = Unique(categoryItemsProj.filter(financial => financial.Platform == platform).map(financial => financial.Projection_Date), true).sort((a, b) => { return new Date(a).getTime() - new Date(b).getTime(); });
                    const finalMonthProj = monthsProj[monthsProj.length - 1];
                    const monthsTrend = Unique(categoryItemsTrend.filter(financial => financial.Platform == platform).map(financial => financial.Projection_Date), true).sort((a, b) => { return new Date(a).getTime() - new Date(b).getTime(); });
                    const lastMonthTrend = monthsTrend[monthsTrend.length - 1];
                    budget += Math.round(categoryItemsProj.filter(financial => financial.Deliverable == deliverable && financial.Platform == platform && financial.Projection_Date == finalMonthProj).reduce((acc, item) => acc + item.cost_budgeted, 0));
                    forecastProj += Math.round(categoryItemsProj.filter(financial => financial.Deliverable == deliverable && financial.Platform == platform && financial.Projection_Date == finalMonthProj).reduce((acc, item) => acc + item.Projected_Spending, 0));
                    forecastTrend += Math.round(categoryItemsTrend.filter(financial => financial.Deliverable == deliverable && financial.Platform == platform && financial.Projection_Date == lastMonthTrend).reduce((acc, item) => acc + item.Projected_Spending, 0));
                });


                tempDeliverable.name = deliverable;

                tempDeliverable.budget = budget;
                tempDeliverable.forecastProj = forecastProj;
                tempDeliverable.forecastTrend = forecastTrend;

                drilldowns.push(tempDeliverable);
            });


            temp.DrillDown = drilldowns;
            temp.initialize();

            localCategoryItems.push(temp);

        });
        return localCategoryItems;
    }


    public drillupTable(): void {
        // Drilldown the charts
        $(".table-drillup-container").addClass("d-none");
        this.forecastBarChart.drillUp();
    }

    redrawChart(forecastTEData: FinancialForecastEntry[], forecastPEData: FinancialForecastEntry[]): void {
        this.graphData = this.createGraphData(forecastTEData, forecastPEData);
        let updatedSeries = this.getExpenditureSeries(this.graphData);


        // 1. Clear existing series
        while (this.forecastBarChart.series.length) {
            this.forecastBarChart.series[0].remove(false); // false = don't redraw yet
        }

        // 2. Add new primary series
        updatedSeries.primarySeries.forEach(s => {
            this.forecastBarChart.addSeries(s, false);
        });

        // 3. Update drilldown series directly
        this.forecastBarChart.options.drilldown = this.forecastBarChart.options.drilldown || {};
        this.forecastBarChart.options.drilldown.series = updatedSeries.drillDownSeries;

        // 4. Redraw the chart
        this.forecastBarChart.redraw();


        //this.forecastBarChart.update({
        //    series: this.getExpenditureSeries(this.graphData)
        //}, true);
        //this.forecastBarChart.redraw();
    }
}